import { $clientTeamMembers, $clientTeamParticipationList } from './states';
import { fetchClientTeamMembers, fetchClientTeamParticipationList } from './effects';

// Set client team members
$clientTeamMembers.on(
    fetchClientTeamMembers.doneData,
    (_, data) => data,
);

// Client team participation list
$clientTeamParticipationList.on(
    fetchClientTeamParticipationList.doneData,
    (_, data) => data,
);
